class QuickView {
      constructor() {
          this.quickViewButtons = document.querySelectorAll('.quick-view-button');
          this.addToCartButtons = document.querySelectorAll('.add_to_cart_button');
          this.quickViewDrawer = document.getElementById('quick-view-drawer');
          this.quickViewContent = document.getElementById('quick-view-content');
          this.closeButton = document.getElementById('close-quick-view');
          this.moneyFormat = '${{amount}}';
          this.init();
      }
  
    init() {
        // Handle direct add-to-cart for single-variant products
        this.addToCartButtons.forEach(button => {
            button.addEventListener('click', () => {
                const variantId = button.dataset.id;
                this.addToCart(variantId, button);
            });
        });
    
        this.quickViewButtons.forEach(button => {
            button.addEventListener('click', () => {
                const productHandle = button.dataset.productHandle;
                this.openQuickView(productHandle);
            });
        });
    
        this.closeButton.addEventListener('click', () => {
            this.quickViewDrawer.classList.remove('open');
            document.body.classList.remove('overflow-hidden'); // Restore body scroll
        });
    
        document.addEventListener('click', (event) => {
            if (event.target.classList.contains('add-to-cart-button')) {
                const addToCartButton = event.target;
                const variantId = addToCartButton.dataset.id;
                if (variantId) {
                    // Show loading state
                    addToCartButton.disabled = true;
                    addToCartButton.textContent = 'Adding...';
    
                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: variantId, quantity: 1 })
                    })
                    .then(response => response.json())
                    .then(() => {
                        // Reset button state
                        addToCartButton.disabled = false;
                        addToCartButton.textContent = 'Add to Cart';
    
                        this.quickViewDrawer.classList.remove('open');
                        document.body.classList.remove('overflow-hidden'); // Restore body scroll
                        document.querySelector('.nudge-offer')?.remove();
                        document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem'));
                        if (typeof InCartUpsell !== 'undefined' && typeof InCartUpsell.prototype.findOfferWhenReady === 'function') {
                            InCartUpsell.prototype.findOfferWhenReady();
                        }
                    })
                    .catch(error => {
                        console.error('Error adding to cart:', error);
                        addToCartButton.disabled = false;
                        addToCartButton.textContent = 'Add to Cart';
                    });
                }
            }
        });
    }

    
  
    currency_formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;
      
        function formatWithDelimiters(
          number,
          precision = 2,
          thousands = ',',
          decimal = '.'
        ) {
          if (isNaN(number) || number == null) {
            return 0;
          }
      
          number = (number / 100.0).toFixed(precision);
      
          const parts = number.split('.');
          const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            `$1${thousands}`
          );
          const centsAmount = parts[1] ? decimal + parts[1] : '';
      
          return dollarsAmount + centsAmount;
        }
      
        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }
      
        return formatString.replace(placeholderRegex, value);
    }

    // Function to add a product to the cart directly
    addToCart(variantId, button) {
        if (!variantId) return;

        // Show loading state
        button.disabled = true;
        button.textContent = 'Adding...';

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
        })
            .then(response => response.json())
            .then(() => {
                // Reset button state
                button.disabled = false;
                button.textContent = 'Add to Cart';

                // Dispatch Shopify cart update event
                document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem'));
                
                // If InCartUpsell exists, trigger upsell offers
                if (typeof InCartUpsell !== 'undefined' && typeof InCartUpsell.prototype.findOfferWhenReady === 'function') {
                    InCartUpsell.prototype.findOfferWhenReady();
                }
            })
            .catch(error => {
                console.error('Error adding to cart:', error);
                button.disabled = false;
                button.textContent = 'Add to Cart';
            });
    }

    openQuickView(productHandle) {
        
        fetch(`/products/${productHandle}.js`)
            .then(response => response.json())
            .then(product => {
                console.log(product,"products");
                let variantOptionsHTML = '';
                let selectedOptions = new Array(product.options.length).fill(null);

                if (product.options.length > 0) {
                    product.options.forEach((optionName, optionIndex) => {
                        const uniqueValues = [...new Set(product.variants.map(variant => variant.options[optionIndex]))];

                        variantOptionsHTML += `
                            <div class="quick-view-option-group">
                                <span class="quick-view-option-label">${optionName.name}:</span>
                                <div class="quick-view-options" data-option-index="${optionIndex}">
                                    ${uniqueValues
                                        .map((value, index) => `
                                            <span class="quick-view-option ${index === 0 ? 'selected' : ''}" data-value="${value}">
                                                ${value}
                                            </span>
                                        `)
                                        .join('')}
                                </div>
                            </div>
                        `;

                        selectedOptions[optionIndex] = uniqueValues[0];
                    });
                }

                // Create product image slider HTML
                const imageSliderHTML = `
                    <div class="quick-view-slider">
                        <div class="slider-wrapper">
                            ${product.images
                                .map(
                                    (image, index) => `
                                        <div class="slider-slide ${index === 0 ? 'active' : ''}">
                                            <img src="${image}" alt="${product.title}" class="slider-image">
                                        </div>
                                    `
                                )
                                .join('')}
                        </div>
                        <button class="slider-prev">❮</button>
                        <button class="slider-next">❯</button>
                    </div>
                `;
                let regularPrice = this.currency_formatMoney(product.price, theme.moneyFormat);
                let salePrice = '';
                if (product.compare_at_price > product.price) {
                    regularPrice = this.currency_formatMoney(product.price, theme.moneyFormat);
                    salePrice = this.currency_formatMoney(product.compare_at_price, theme.moneyFormat);
                }
                this.quickViewContent.innerHTML = `
                    <div class="quick-view-product">
                        ${imageSliderHTML}
                        <h2 class="quick-view-title">${product.title}</h2>

                        <s class="block lg:inline quick-view-cprice">${salePrice}</s>
                        <span class="quick-view-price">${regularPrice}</span>
                        
                       
                        ${variantOptionsHTML}
                        <div class="quick_atc_btn_wrp">
                            <button class="add-to-cart-button" data-id="">
                                Add to Cart
                            </button>
                        </div>

                        <a href="${product.url}" class="view_full_pdct">See full details</a>
                    </div>
                `;

                this.quickViewDrawer.classList.add('open');
                document.body.classList.add('overflow-hidden'); // Prevent body scroll
                this.initializeSlider(); // Initialize the slider functionality
                this.handleVariantSelection(product, selectedOptions);
            })
            .catch(error => console.error('Error fetching product:', error));
    }

   
    
    handleVariantSelection(product, selectedOptions) {
        const optionGroups = document.querySelectorAll('.quick-view-options');
        const addToCartButton = document.querySelector('.add-to-cart-button');
    
        const defaultVariant = product.variants.find(variant =>
            variant.options.every((option, index) => option === selectedOptions[index])
        );
    
        if (defaultVariant) {
            addToCartButton.setAttribute('data-id', defaultVariant.id);
            addToCartButton.disabled = !defaultVariant.available;
            addToCartButton.textContent = defaultVariant.available ? 'Add to Cart' : 'Sold Out';
        }
    
        optionGroups.forEach(group => {
            group.addEventListener('click', function (event) {
                if (event.target.classList.contains('quick-view-option')) {
                    const optionIndex = parseInt(this.dataset.optionIndex);
                    const selectedValue = event.target.dataset.value;
    
                    group.querySelectorAll('.quick-view-option').forEach(option => option.classList.remove('selected'));
                    event.target.classList.add('selected');
    
                    selectedOptions[optionIndex] = selectedValue;
    
                    const matchingVariant = product.variants.find(variant =>
                        variant.options.every((option, index) => option === selectedOptions[index])
                    );
    
                    if (matchingVariant) {
                        addToCartButton.setAttribute('data-id', matchingVariant.id);
                        addToCartButton.disabled = !matchingVariant.available;
                        addToCartButton.textContent = matchingVariant.available ? 'Add to Cart' : 'Sold Out';
                    } else {
                        addToCartButton.setAttribute('data-id', '');
                        addToCartButton.disabled = true;
                        addToCartButton.textContent = 'Sold Out';
                    }
                }
            });
        });
    }
    
    initializeSlider() {
        const slides = document.querySelectorAll('.slider-slide');
        const prevButton = document.querySelector('.slider-prev');
        const nextButton = document.querySelector('.slider-next');
        let currentIndex = 0;

        function showSlide(index) {
            slides.forEach((slide, idx) => {
                slide.classList.toggle('active', idx === index);
            });
        }

        prevButton.addEventListener('click', function () {
            currentIndex = (currentIndex > 0) ? currentIndex - 1 : slides.length - 1;
            showSlide(currentIndex);
        });

        nextButton.addEventListener('click', function () {
            currentIndex = (currentIndex < slides.length - 1) ? currentIndex + 1 : 0;
            showSlide(currentIndex);
        });
    }

}
document.addEventListener('DOMContentLoaded', () => {
    window.quickViewInstance = new QuickView();
});